import type { ComponentType, SVGProps } from 'react';
import AlertTriangle16 from './alert-triangle-16.svg';
import DirectionArrowDown16 from './direction-arrow-down-16.svg';
import DirectionArrowRight16 from './direction-arrow-right-16.svg';
import DirectionChevronRight16 from './direction-chevron-right-16.svg';
import MathSymbolsPlus16 from './math-symbols-plus-16.svg';
import ValidationCheckBold16 from './validation-check-bold-16.svg';

type SharedIconComponent = ComponentType<SVGProps<SVGSVGElement> & { title?: string }>;

export const namedIconRegistry = {
  'alert-triangle': AlertTriangle16,
  'direction-arrow-down': DirectionArrowDown16,
  'direction-arrow-right': DirectionArrowRight16,
  'direction-chevron-right': DirectionChevronRight16,
  'math-symbols-plus': MathSymbolsPlus16,
  'validation-check-bold': ValidationCheckBold16,
} satisfies Record<string, SharedIconComponent>;

export type NamedIconName = keyof typeof namedIconRegistry;

export const namedIconNames = Object.keys(namedIconRegistry) as NamedIconName[];

export const isNamedIconName = (name: string): name is NamedIconName =>
  Object.prototype.hasOwnProperty.call(namedIconRegistry, name);
